import { render, staticRenderFns } from "./project-connect.vue?vue&type=template&id=cb3dfd16"
import script from "./project-connect.vue?vue&type=script&lang=js"
export * from "./project-connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports